module.exports = __webpack_public_path__ + "static/img/example3.2541368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/example3.jpg
// module id = IfkT
// module chunks = 1